import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Event, NavigationEnd, NavigationError, NavigationStart, ParamMap, Router } from '@angular/router';
import { MaestraService } from 'src/app/service/maestra/maestra.service';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-pagina-inicial',
  templateUrl: './pagina-inicial.component.html',
  styleUrls: ['./pagina-inicial.component.scss']
})
export class PaginaInicialComponent implements OnInit {
  idMenu: String;
  flagChange: boolean = false;
  element: boolean = false;
  factiveT="divHover";
  factiveN="active";
  factiveC="divHover";
  factiveM="divHover";
  factiveCO="divHover";
  factiveTR="divHover";

  //VARIABLES MICROSITIOS
  nuevos=true;
  morado:any;
  verde:any;
  azul:any;
  amarillo:any;
  todos:any;

  constructor(private route: ActivatedRoute, private router: Router, private maestraService: MaestraService, private titleService: Title) {
    this.titleService.setTitle("MEMORIA PERÚ");
    this.nuevos =true;
    this.morado = false;
    this.verde = false;
    this.azul = false;
    this.amarillo = false;
    this.todos = false;
  }
  dirigirTema() {
    console.log(this.idMenu)
    if (this.idMenu != null) {


      document.querySelector('#' + this.idMenu).scrollIntoView({ behavior: 'smooth', block: 'center' });
      this.flagChange = false;

    }
  }

  checkIfLoaded(idMenu) {
    window.addEventListener("load", function (event) {
      document.querySelector('#' + idMenu).scrollIntoView({ behavior: 'smooth', block: 'center' });
    });
  }

  ngAfterContentChecked() {
    if (this.flagChange) {

      setTimeout(() => this.dirigirTema(), 300);
    }
    // this.maestraService.loading=false; 
  }

  ngOnInit(): void {
    this.route.paramMap.subscribe((params: ParamMap) => {
      this.idMenu = params.get('idMenu');
      this.flagChange = true;
      //this.checkIfLoaded(this.idMenu); 
      //this.dirigirTema();    
    });
  }

  showData() {
    return (this.element = true);
  }
  hideData() {
    return (this.element = false);
  }


  asignar(a){
    this.factiveN = a=='NUEVOS'?'active':'divHover';
    this.factiveT = a=='TODOS'?'active':'divHover';
    this.factiveC = a=='CREADORES'?'active':'divHover';
    this.factiveM = a=='MIRADAS'?'active':'divHover';
    this.factiveCO = a=='COMUNIDADES'?'active':'divHover';
    this.factiveTR = a=='TRANSICIONES'?'active':'divHover';
    
    if(a=="CREADORES"){
      this.morado = true;
      this.verde = false;
      this.azul = false;
      this.amarillo = false;
      this.todos = false;
      this.nuevos =false;
    }else if(a=="MIRADAS"){
      this.morado = false;
      this.verde = true;
      this.azul = false;
      this.amarillo = false;
      this.todos = false;
      this.nuevos =false;
    }else if(a=="TRANSICIONES"){
      this.morado = false;
      this.verde = false;
      this.azul = true;
      this.amarillo = false;
      this.todos = false;
      this.nuevos =false;
    }else if(a=="COMUNIDADES"){
      this.morado = false;
      this.verde = false;
      this.azul = false;
      this.amarillo = true;
      this.todos = false;
      this.nuevos =false;
    }else if(a=="NUEVOS"){
      this.morado = false;
      this.verde = false;
      this.azul = false;
      this.amarillo = false;
      this.todos = false;
      this.nuevos =true;
    }else{
      this.morado = false;
      this.verde = false;
      this.azul = false;
      this.amarillo = false;
      this.todos = true;
      this.nuevos =false;
    }

  }

}
